module.exports = __webpack_public_path__ + "static/media/sidebar4.78491488.jpg";